import { useCallback } from "react";
import { StartrackingEventsNames } from "@/lib/startrack/trackingEvents";
import { sendKibanaLog } from "@/app/api/sendKibanaLog";
import { sendTrackWayEventsViaBrg } from "../trackway";
import { AppConfig } from "@/lib/Types/AppConfig";

const eventsData = {
  FILTER_APPLIED: {
    name: StartrackingEventsNames.FilterApplied,
    version: "1.2",
  },
  CHECK_UPSELLING_OPTIONS: {
    name: StartrackingEventsNames.CheckUpsellingOptions,
    version: "1.1",
  },
  CHECK_AVAILABILITY: {
    name: StartrackingEventsNames.CheckAvailability,
    version: "1.4",
  },
  RESULT_CLICKED: {
    name: StartrackingEventsNames.ResultClicked,
    version: "1.5",
  },
  PRODUCT_DETAIL_CLICKED: {
    name: StartrackingEventsNames.ProductDetailClicked,
    version: "1.7",
  },
  RESULT_PAGE_SHOWN: {
    name: StartrackingEventsNames.ResultPageShown,
    version: "1.2",
  },
  PRODUCT_DETAIL_SHOWN: {
    name: StartrackingEventsNames.ProductDetailShown,
    version: "1.8",
  },
  CHECKOUT_SHOWN: {
    name: StartrackingEventsNames.CheckoutShown,
    version: "1.5",
  },
  CHECKOUT_CLICK2PAY: {
    name: StartrackingEventsNames.CheckoutClick2Pay,
    version: "1.1",
  },
  INSURANCE_CLICKED: {
    name: StartrackingEventsNames.InsuranceClicked,
    version: "1.1",
  },
  INSURANCE_REPROPOSAL_SHOWN: {
    name: StartrackingEventsNames.InsuranceReproposalShown,
    version: "1.1",
  },
  INSURANCE_REPROPOSAL_CLICKED: {
    name: StartrackingEventsNames.InsuranceReproposalClicked,
    version: "1.1",
  },
  THANK_YOU_PAGE_SHOWN: {
    name: StartrackingEventsNames.ThankYouPageShown,
    version: "1.2",
  },
  PRE_RESULT_PAGE_SHOWN: {
    name: StartrackingEventsNames.PreResultPageShown,
    version: "1.0",
  },
  PRE_RESULT_PAGE_CLICKED: {
    name: StartrackingEventsNames.PreResultPageClicked,
    version: "1.0",
  },
  PRODUCT_DETAIL_PRICE_CALENDAR_CLICKED: {
    name: StartrackingEventsNames.ProductDetailPriceCalendarClicked,
    version: "1.1",
  },
  PRODUCT_DETAIL_PRICE_CALENDAR_OPEN_INTERACTION: {
    name: StartrackingEventsNames.ProductDetailPriceCalendarOpenInteraction,
    version: "1.1",
  },
  PRODUCT_DETAIL_PRICE_CALENDAR_SCROLLING_INTERACTION: {
    name: StartrackingEventsNames.ProductDetailPriceCalendarScrollingInteraction,
    version: "1.1",
  },
  VOUCHER_REDEMPTION_RESPONSE: {
    name: StartrackingEventsNames.VoucherRedemptionResponse,
    version: "1.1",
  },

  MAP_CLICKED: {
    name: StartrackingEventsNames.MapClicked,
    version: "1.0",
  },
};

export type StartrackEventNameType = keyof typeof eventsData;

function useTracking(appConfig: AppConfig) {
  const { WlConfig, envConfig, mpt } = appConfig;
  const trackway = WlConfig.trackway;
  const track = useCallback(
    (eventName: StartrackEventNameType, payload: any) => {
      const transactionId =
        new URLSearchParams(window.location.search).get("transactionId") ||
        payload?.transactionId ||
        undefined;

      const eventConfig = eventsData[eventName] as { name: StartrackingEventsNames; version: string; channel?: string };
      const eventPayloady = {
        payload: { ...payload, platformName: "ICARUS" },
        name: eventConfig.name,
        version: eventConfig.version,
      };
      sendTrackWayEventsViaBrg(
        eventPayloady,
        trackway,
        mpt || undefined,
        envConfig || undefined,
        eventConfig.channel,
      );
      if (envConfig) {
        sendKibanaLog({
          envConfig,
          message: `STARTRACK EVENT SENT`,
          component: "startrack",
          category: "startrack",
          jsonMessage: eventPayloady,
          transactionId,
        });
      }
    },
    [trackway, envConfig, mpt],
  );
  return { track };
}
export default useTracking;
